function resizeObserverFunctions() {
    // put your functions that needs resize observer here
}

function resizeObserver() {
}

jQuery( document )
    .on( "mfr:styles-rendered", resizeObserver )
    .on( "shopify:section:load", resizeObserver );